// src/components/ui/card.jsx
import React from "react";

export const Card = ({ children, className }) => {
  return (
    <div className={`bg-white p-4 rounded-lg shadow-md ${className}`}>
      {children}
    </div>
  );
};

export const CardHeader = ({ children }) => {
  return <div className="text-xl font-semibold">{children}</div>;
};

export const CardTitle = ({ children }) => {
  return <div className="text-lg font-bold">{children}</div>;
};

export const CardDescription = ({ children }) => {
  return <div className="text-sm text-gray-600">{children}</div>;
};

export const CardContent = ({ children }) => {
  return <div className="mt-2">{children}</div>;
};

export const CardFooter = ({ children }) => {
  return <div className="mt-4 text-sm text-gray-500">{children}</div>;
};
